namespace RioERP.Carts {
    export interface CartProductBillingItemsTaxForm {
        CartId: Serenity.IntegerEditor;
        CartProductsId: Serenity.IntegerEditor;
        TaxTypeId: Serenity.IntegerEditor;
        Rate: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
        IsActive: Serenity.BooleanEditor;
        InsertUserId: Serenity.IntegerEditor;
        InsertDate: Serenity.DateEditor;
        UpdateUserId: Serenity.IntegerEditor;
        UpdateDate: Serenity.DateEditor;
        CartProductBillingItemsId: Serenity.IntegerEditor;
    }

    export class CartProductBillingItemsTaxForm extends Serenity.PrefixedContext {
        static formKey = 'Carts.CartProductBillingItemsTax';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CartProductBillingItemsTaxForm.init)  {
                CartProductBillingItemsTaxForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.BooleanEditor;
                var w3 = s.DateEditor;

                Q.initFormType(CartProductBillingItemsTaxForm, [
                    'CartId', w0,
                    'CartProductsId', w0,
                    'TaxTypeId', w0,
                    'Rate', w1,
                    'TaxAmount', w1,
                    'IsActive', w2,
                    'InsertUserId', w0,
                    'InsertDate', w3,
                    'UpdateUserId', w0,
                    'UpdateDate', w3,
                    'CartProductBillingItemsId', w0
                ]);
            }
        }
    }
}
